import React, { useState } from 'react';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
// import FlatButtons from '../../components/FlatButton/FlatButton';
import AnimatedButton from '../../components/AnimatedButton';

interface FormData {
  name: string;
  email: string;
  priceRange: string;
  storeType: string;
  storeSize: string;
  maxProductCapacity: string;
  description: string;
}

export const StoreCustomRequestForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    email: '',
    priceRange: '',
    storeType: '',
    storeSize: '',
    maxProductCapacity: '',
    description: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsSubmitted(true);

    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        priceRange: '',
        storeType: '',
        storeSize: '',
        maxProductCapacity: '',
        description: ''
      });
    }, 3000);
  };

  if (isSubmitted) {
    return (
      <div className={styles.customStore}>
        <div className={styles.contentWrapper}>
          <div className={styles.successMessage}>
            <Typography
              variant='bodyLarge'
              fontFamily='satoshi'
              weight='regular'
              className={styles.successText}>
              Your request has been received successfully. Our team would get back to you in a short while via email
            </Typography>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.customStore}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <Typography
              variant='heading5'
              fontFamily='satoshi'
              weight='bold'
              className={styles.title}>
              Do you have something specific in mind for your store?
            </Typography>
            <Typography
              variant='bodyRegular'
              fontFamily='satoshi'
              weight='regular'
              className={styles.description}>
              Whether you're showcasing a single piece or curating an entire
              virtual store, we'll tailor a solution that fits your creative and
              commercial needs. Fill out the form below and our team will get
              back to you with a personalized quote.
            </Typography>
          </div>
        </div>

        <div className={styles.formContent}>
          <div className={styles.gridContainer}>
            <div className={styles.inputGroup}>
              <label htmlFor="name" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Name
                </Typography>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="John Doe"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="storeType" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Store Type
                </Typography>
              </label>
              <input
                type="text"
                id="storeType"
                name="storeType"
                value={formData.storeType}
                onChange={handleInputChange}
                placeholder="e.g., Art Gallery, Fashion Boutique"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="email" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Email
                </Typography>
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="johndoe@gmail.com"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="storeSize" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Store Size
                </Typography>
              </label>
              <input
                type="text"
                id="storeSize"
                name="storeSize"
                value={formData.storeSize}
                onChange={handleInputChange}
                placeholder="Small, Medium, Large"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="priceRange" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Price Range
                </Typography>
              </label>
              <input
                type="text"
                id="priceRange"
                name="priceRange"
                value={formData.priceRange}
                onChange={handleInputChange}
                placeholder="$500 - $2000"
                required
                className={styles.input}
              />
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="maxProductCapacity" className={styles.label}>
                <Typography
                  variant='bodyRegular'
                  fontFamily='satoshi'
                  weight='regular'
                  className={styles.labelText}>
                  Maximum Product Capacity
                </Typography>
              </label>
              <input
                type="text"
                id="maxProductCapacity"
                name="maxProductCapacity"
                value={formData.maxProductCapacity}
                onChange={handleInputChange}
                placeholder="50 products"
                required
                className={styles.input}
              />
            </div>
          </div>

          <div className={styles.textareaGroup}>
            <label htmlFor="description" className={styles.label}>
              <Typography
                variant='bodyRegular'
                fontFamily='satoshi'
                weight='regular'
                className={styles.labelText}>
                Tell us more about the store
              </Typography>
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              placeholder="Describe your vision, specific requirements, or any special features you'd like..."
              rows={6}
              className={styles.textarea}
            />
          </div>

          <div className={styles.submitSection}>
            <AnimatedButton
            variant='primary'
              type="button"
              onClick={() => handleSubmit({} as React.MouseEvent<HTMLButtonElement>)}
              className={styles.submitButton}
            >
              <Typography
                variant='buttonText'
                fontFamily='satoshi'
                weight='bold'
                className={styles.submitButtonText}
              >
                Send Request
              </Typography>
            </AnimatedButton>
          </div>
        </div>
      </div>
    </div>
  );
};